<template>

  <div id="service_faqs" v-if="hasFaqs">
    <h3>{{ faqTitle }}  <a :href="faqURL" id="learn_more">{{ learnMore }}</a></h3>

    <div class="panel panel-default " v-for="(faq, index ) in faqs" :key="index">
      <div class="panel-heading accordion-toggle question-toggle collapsed" data-toggle="collapse" data-parent="#faqAccordion" :data-target="'#question' + index">
        <h4 class="panel-title">
          <a href="#" class="ing">{{ faq.question }}</a>
        </h4>
      </div>
      <div :id="'question' + index" class="panel-collapse collapse" style="height: 0px;">
        <div class="panel-body">
          <p>{{ faq.answer}}</p>
        </div>
      </div>
    </div>

  </div>

</template>


<script>

import {getServiceFaqs} from "@/modules/CustomerPortal/api/services/view";
export default {
  name: "ServiceViewRightMenuFaqs",
  components: {getServiceFaqs},
  props: [
    "service_id",
    "company_name",
    "company_id"
  ],
  data() {
    return {
      faqs: [],
      hasFaqs: 0,
      faqURL:'',
      faqTitle:'',
      learnMore:'',
    }
  },
  methods:{

  },
  computed: {

  },
  mounted(){
    getServiceFaqs(this.service_id, this.company_name, this.company_id).then((response) => {
      if(response.status == 200){
        if(response.data.type == 'success'){
          this.faqURL = response.data.data.faqURL;
          this.faqTitle = response.data.data.faqTitle;
          this.learnMore = response.data.data.learnMore;

          this.faqs = response.data.data.faqs;
          this.hasFaqs = 1;
        }
      }
    })
  }
}
</script>
